module.exports = __webpack_public_path__ + "img/Group 43111.8eaeadb6.png";